interface FileExtentionsConfig {
  maxFileSize: number
  zipMaxFileSize: number
  default: {
    [key: string]: string[]
  }
  import: {
    [key: string]: string[]
  }
  zip: {
    [key: string]: string[]
  }
  csv: {
    [key: string]: string[]
  }
  excel: {
    [key: string]: string[]
  }
  custom: {
    [key: string]: string[]
  }
  viewableTypes: string[]
}

export const fileExtensions: FileExtentionsConfig = {
  //The custom accepted formats are JPG, JPEG, PNG or PDF
  //The default accepted formats are XLSX, XLS, CSV, PDF, DOC, TXT, JPG, JPEG, PNG, GIF, TIFF, ZIP
  maxFileSize: 262175457,
  zipMaxFileSize: 500 * 1024 * 1024,
  default: {
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': [
      '.xlsx',
    ],
    'application/vnd.ms-excel': ['.xls'],
    'text/csv': ['.csv'],
    'application/pdf': ['.pdf'],
    'application/msword': ['.doc'],
    'text/plain': ['.txt'],
    'image/jpeg': ['.jpg', '.jpeg'],
    'image/png': ['.png'],
    'image/gif': ['.gif'],
    'image/tiff': ['.tiff'],
    'application/zip': ['.zip'],
  },
  import: {
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': [
      '.xlsx',
    ],
  },
  zip: {
    'application/zip': ['.zip'],
  },
  csv: {
    'text/csv': ['.csv'],
  },
  excel: {
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': [
      '.xlsx',
    ],
    'application/vnd.ms-excel': ['.xls'],
  },
   custom: {
    'application/pdf': ['.pdf'],
    'image/jpeg': ['.jpg', '.jpeg'],
    'image/png': ['.png'],
  },
  viewableTypes: [
    'application/pdf',
    'text/plain',
    'image/jpeg',
    'image/png',
    'image/gif',
    'image/tiff',
  ],
}